import { CHARACTER_PORTRAITS_PAGE_SIZE } from "../../../../../../src/shared/characterPortraits";
import { useEntityImages, type UseEntityImagesResult } from "../../../EntityImage/lib/useEntityImages";
import { listCharacterPortraits } from "./api";

const QUERY_KEY_PREFIX = "characterPortraits";

export type UseCharacterPortraitsResult = UseEntityImagesResult;

const fetchPortraitsPage = (characterId: string, cursor: string | undefined) => listCharacterPortraits(characterId, { limit: CHARACTER_PORTRAITS_PAGE_SIZE, cursor });

export function useCharacterPortraits(characterId: string, { enabled }: { enabled: boolean }): UseCharacterPortraitsResult {
  return useEntityImages({ queryKeyPrefix: QUERY_KEY_PREFIX, entityId: characterId, fetchPage: fetchPortraitsPage, enabled, sentryFeature: "character_portrait_list" });
}
